class UserModelSalt{
    id!: string
    email!: string
    password!: string
}

export {UserModelSalt}